import { Route, Routes } from "react-router-dom";
import { Expenses } from "../Expenses/Expenses";
import { GetStarted } from "../GetStarted/GetStarted";
import { Liabilities } from "../Liabilities/Liabilities";
import { PersonalDetails } from "../PersonalDetails/PersonalDetails";
import { Prescreening } from "../Prescreening/Prescreening";
import { ReasonsForApplying } from "../ReasonsForApplying/ReasonsForApplying";
import { Review } from "../Review/Review";
import { YourAccounts } from "../YourAccounts/YourAccounts";
import { YourIncome } from "../YourIncome/YourIncome";

export const HardshipApplicationRoutes = () => (
  <Routes>
    <Route path="/" element={<GetStarted />} />
    <Route path="prescreening" element={<Prescreening />} />
    <Route path="personal-details" element={<PersonalDetails />} />
    <Route path="accounts" element={<YourAccounts />} />
    <Route path="reasons-for-applying" element={<ReasonsForApplying />} />
    <Route path="your-income" element={<YourIncome />} />
    <Route path="expenses" element={<Expenses />} />
    <Route path="liabilities" element={<Liabilities />} />
    <Route path="review" element={<Review />} />
  </Routes>
);
